<template>
  <div>
    <v-row class="justify-end">
      <v-col cols="12" md="3">
        <v-text-field
          v-model="userSearch"
          label="ค้นหา"
          solo
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :search="userSearch"
      :loading="userLoading"
      :headers="userHeaders"
      :items="users"
      :items-per-page="100"
      sort-by="id"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 75, 100, -1],
      }"
    >
      <template v-slot:[`item.no`]="{ index }">
        {{ index + 1 }}
      </template>
      <template v-slot:[`item.roles`]="{ item }">
        <ChipRole
          v-for="role in item.roles"
          :key="`role_${role.id}`"
          :role="role"
        />
      </template>
      <template v-slot:[`item.available`]="{ item }">
        <v-switch
          :input-value="item.available"
          inset
          @change="onToggleAvailable(item.id)"
        ></v-switch>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <router-link
          :to="{ name: 'OfficeUserEdit', params: { user: item.id } }"
          class="decoration-none"
        >
          <v-icon color="primary" class="mr-2" title="แก้ไขข้อมูล" small>
            fa-edit
          </v-icon>
        </router-link>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import * as UserService from "@/common/service/user.service"
import { UPDATE_BREADCRUMBS, GET_USERS, DELETE_USER } from "@/store/action.type"
import { DATA_UNSUSPENDED, DATA_SUSPENDED, CONFIRM_DELETE } from "@/common/consistent"
import { swalConfirm, swalToast } from "@/common/alert"
import { ChipRole } from "@/components/chip"

export default {
  name: "OfficeUser",
  title: "จัดการผู้ใช้งาน",
  components: {
    ChipRole,
  },
  created() {
    this.$store.dispatch(UPDATE_BREADCRUMBS, [
      {
        text: "ผู้ใช้งาน",
        disabled: false,
        exact: true,
        to: { name: "OfficeUser" },
      },
    ])
  },
  data() {
    return {
      userSearch: "",
      userHeaders: [
        { text: "ID", value: "id" },
        { text: "username", value: "username" },
        { text: "ชื่อ - สกุล", value: "full_name" },
        { text: "สถานะ", value: "roles" },
        { text: "การใช้งาน", value: "available" },
        { text: "ตัวเลือก", value: "actions" },
      ],
      showUser: {},
    }
  },
  computed: {
    ...mapGetters(["users", "userLoading"]),
  },
  mounted() {
    this.getUser()
  },
  methods: {
    getUser() {
      this.$store.dispatch(GET_USERS)
    },
    openDialogCreateUser() {
      this.dialogCreateUser = true
    },
    async onToggleAvailable(userId) {
      const res = await UserService.toggleAvailable(userId)

      if(res.result) {
        const msg = res.available ? DATA_UNSUSPENDED : DATA_SUSPENDED
  
        this.getUser()
        swalToast("success", msg)
      }
    },
  },
}
</script>
